import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Injectable, Inject, PLATFORM_ID, NgModule } from '@angular/core';
import * as i1 from 'ngx-logger';
import { NGXLoggerMetadataService, NGXLoggerWriterService, NGXLoggerServerService, TOKEN_LOGGER_CONFIG, TOKEN_LOGGER_WRITER_SERVICE, TOKEN_LOGGER_CONFIG_ENGINE_FACTORY, NGXLoggerConfigEngineFactory, TOKEN_LOGGER_METADATA_SERVICE, TOKEN_LOGGER_RULES_SERVICE, NGXLoggerRulesService, TOKEN_LOGGER_MAPPER_SERVICE, NGXLoggerMapperService, TOKEN_LOGGER_SERVER_SERVICE, LoggerModule } from 'ngx-logger';
import * as i1$1 from '@angular/common/http';
import { HttpHeaders, HttpClientModule } from '@angular/common/http';
import { of } from 'rxjs';

class AngularLoggerUserInfoService {
    getUserMetaDataAsString(config) {
        return null;
    }
    ;
    getUserMetaDataAsObject(config) {
        return null;
    }
    ;
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.11", ngImport: i0, type: AngularLoggerUserInfoService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.11", ngImport: i0, type: AngularLoggerUserInfoService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.11", ngImport: i0, type: AngularLoggerUserInfoService, decorators: [{
            type: Injectable
        }] });

/**
 * Injection token of logger user info service
 */
const TOKEN_ANGULAR_LOGGER_USERINFO_SERVICE = 'TOKEN_ANGULAR_LOGGER_USERINFO_SERVICE';

class LoggerMetadataService extends NGXLoggerMetadataService {
    constructor(userInfoService) {
        super(null);
        this.userInfoService = userInfoService;
    }
    getMessageObject(config, messagePayload, meta) {
        let messageObject;
        if (typeof meta == 'string') {
            meta = { "data": meta };
        }
        const userMeta = this.userInfoService.getUserMetaDataAsObject(config);
        if (typeof messagePayload == 'object') {
            messageObject = {
                ...messagePayload,
                ...meta
            };
        }
        else if (typeof messagePayload == 'function') {
            let messagePayloadValue = messagePayload();
            messageObject = {
                ...messagePayloadValue,
                ...meta
            };
        }
        else {
            messageObject = {
                message: messagePayload,
                code: null,
                id: null,
                ...meta
            };
        }
        if (userMeta) {
            messageObject = { ...messageObject, ...userMeta };
        }
        return messageObject;
    }
    getMetadata(level, config, message, additional) {
        return super.getMetadata(level, config, this.getMessageObject(config, message, additional[0]));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.11", ngImport: i0, type: LoggerMetadataService, deps: [{ token: TOKEN_ANGULAR_LOGGER_USERINFO_SERVICE }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.11", ngImport: i0, type: LoggerMetadataService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.11", ngImport: i0, type: LoggerMetadataService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [TOKEN_ANGULAR_LOGGER_USERINFO_SERVICE]
                }] }]; } });

class AngularLoggerService {
    constructor(ngxLogger) {
        this.ngxLogger = ngxLogger;
    }
    ;
    /**
          ```
          @LogMessages
          export class ApplicationErrors   {
            
              @ErrorMessage( "An error occured ${0,<Error Details>}")
              static GSPAE000001_MyError
          }
  
          ```
     */
    /**
     * @param  {string|LoggerMessageObject|any} message String of message object from class method decorated with `@EventMessage`
     * @param  {Object} meta? Dynamic meta information. Special handling for object keys `category` and `context`
     */
    debug(message, meta) {
        this.ngxLogger.debug(message, meta);
    }
    /**
     * @param  {string|LoggerMessageObject|any} message String of message object from class method decorated with `@EventMessage`
     * @param  {Object} meta? Dynamic meta information. Special handling for object keys `category` and `context`
     */
    log(message, meta) {
        this.ngxLogger.log(message, meta);
    }
    /**
     * @param  {string|LoggerMessageObject|any} message String of message object from class method decorated with `@EventMessage`
     * @param  {Object} meta? Dynamic meta information. Special handling for object keys `category` and `context`
     */
    warn(message, meta) {
        this.ngxLogger.warn(message, meta);
    }
    /**
     * @param  {string|LoggerMessageObject|any} message String of message object from class method decorated with `@ErrorMessage`
     * @param  {Object} meta? Dynamic meta information. Special handling for object keys `category` and `context`
     */
    error(message, meta) {
        this.ngxLogger.error(message, meta);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.11", ngImport: i0, type: AngularLoggerService, deps: [{ token: i1.NGXLogger }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.11", ngImport: i0, type: AngularLoggerService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.11", ngImport: i0, type: AngularLoggerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.NGXLogger }]; } });

class LoggerTransportConsole extends NGXLoggerWriterService {
    constructor(_platformId, userInfoService) {
        super(_platformId);
        this.userInfoService = userInfoService;
        this.prepareMetaStringFuncs = [
            this.getTimestampToWrite,
            this.getLevelToWrite,
            this.getContextToWrite,
            this.getCodeToWrite,
            //        this.getUserInfoToWrite,
        ];
    }
    getTimestampToWrite(metadata, config) {
        // Removed moment due to https://github.com/moment/moment/issues/4229
        const addZero = (i) => {
            if (i < 10) {
                i = "0" + i;
            }
            return i;
        };
        let timestamp = metadata.timestamp;
        try {
            const timestampDate = new Date(timestamp);
            timestamp = `${addZero(timestampDate.getHours())}:${addZero(timestampDate.getMinutes())}:${addZero(timestampDate.getSeconds())}`;
        }
        catch (err) {
        }
        return timestamp;
    }
    getUserInfoToWrite(metadata, config) {
        return this.userInfoService.getUserMetaDataAsString(config);
        // return config.userInfoProvider(config);
    }
    getCodeToWrite(metadata, config) {
        let msg = metadata?.message?.code ? "[" + metadata.message.code + "] " : '';
        msg = metadata?.message?.context ? "[" + metadata.message.context + "] " + msg : msg;
        msg = metadata?.message?.category ? "[" + metadata.message.category + "] " + msg : msg;
        return msg;
    }
    prepareMetaString(metadata, config) {
        return super.prepareMetaString(metadata, config);
    }
    writeMessage(metadata, config) {
        const metaString = this.prepareMetaString(metadata, config);
        let userString = this.userInfoService.getUserMetaDataAsString(config);
        userString = userString ? (' ' + userString) : '';
        if (metadata.message.message) {
            metadata.message.message = metadata.message.message + userString + ' ' + this.getFileDetailsToWrite(metadata, config);
            this.logFunc(metadata.message, config, metaString);
        }
        else {
            metadata.message.message = metadata.message;
            this.logFunc(metadata.message, config, metaString);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.11", ngImport: i0, type: LoggerTransportConsole, deps: [{ token: PLATFORM_ID }, { token: TOKEN_ANGULAR_LOGGER_USERINFO_SERVICE }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.11", ngImport: i0, type: LoggerTransportConsole, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.11", ngImport: i0, type: LoggerTransportConsole, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [TOKEN_ANGULAR_LOGGER_USERINFO_SERVICE]
                }] }]; } });

class LoggerTransportServerService extends NGXLoggerServerService {
    constructor(_httpBackend, _ngZone, config) {
        super(_httpBackend, _ngZone);
        this.config = config;
    }
    logOnServer(url, logContent, options) {
        try {
            const json = JSON.parse(logContent?.message);
            logContent = {
                ...logContent,
                message: logContent.message,
                ...json,
                level: ['', 'debug', 'info', 'info', 'warn', 'error'][logContent.level]
            };
            if (this.config.setHeadersCallback) {
                options.headers = options.headers ?? new HttpHeaders();
                try {
                    options.headers = this.config.setHeadersCallback(options.headers);
                }
                catch (err) {
                    console.log("Error in setHeadersCallback");
                    console.log(err);
                }
            }
            return super.logOnServer(url, logContent, options);
        }
        catch (err) {
            console.log("Error while trying to log on server");
            console.log(logContent?.message);
            console.log(err);
            return of({});
        }
    }
    ;
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.11", ngImport: i0, type: LoggerTransportServerService, deps: [{ token: i1$1.HttpBackend }, { token: i0.NgZone }, { token: 'TOKEN_LOGGER_CONFIG' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.11", ngImport: i0, type: LoggerTransportServerService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.11", ngImport: i0, type: LoggerTransportServerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$1.HttpBackend }, { type: i0.NgZone }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['TOKEN_LOGGER_CONFIG']
                }] }]; } });

class AngularLoggerModule {
    static forRoot(config) {
        if (!config.userInfoProvider) {
            config.userInfoProvider = { provide: TOKEN_ANGULAR_LOGGER_USERINFO_SERVICE, useClass: AngularLoggerUserInfoService };
        }
        else {
            // if the user provided its own config, we just make sure the injection token is correct
            if (config.userInfoProvider.provide !== TOKEN_ANGULAR_LOGGER_USERINFO_SERVICE) {
                throw new Error(`Wrong injection token for userInfoProvider, it should be ${TOKEN_ANGULAR_LOGGER_USERINFO_SERVICE} and you used ${config.userInfoProvider.provide}`);
            }
        }
        return {
            ngModule: AngularLoggerModule,
            providers: [
                {
                    provide: TOKEN_LOGGER_CONFIG,
                    useValue: {
                        ...config,
                        proxiedSteps: 1,
                        enableSourceMaps: true,
                        serverLoggingUrl: config.serverLogging ? (config.serverLogging.rootUrl + '/' + config.serverLogging.endpointPath) : '',
                        withCredentials: true,
                        serverLogLevel: config.serverLogging?.level,
                        setHeadersCallback: config.serverLogging?.setHeadersCallback
                    }
                },
                config.userInfoProvider,
                { provide: TOKEN_LOGGER_WRITER_SERVICE, useClass: LoggerTransportConsole },
                { provide: TOKEN_LOGGER_CONFIG_ENGINE_FACTORY, useClass: NGXLoggerConfigEngineFactory },
                { provide: TOKEN_LOGGER_CONFIG_ENGINE_FACTORY, useClass: NGXLoggerConfigEngineFactory },
                { provide: TOKEN_LOGGER_METADATA_SERVICE, useClass: LoggerMetadataService },
                { provide: TOKEN_LOGGER_RULES_SERVICE, useClass: NGXLoggerRulesService },
                { provide: TOKEN_LOGGER_MAPPER_SERVICE, useClass: NGXLoggerMapperService },
                { provide: TOKEN_LOGGER_SERVER_SERVICE, useClass: LoggerTransportServerService },
            ]
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.11", ngImport: i0, type: AngularLoggerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.11", ngImport: i0, type: AngularLoggerModule, imports: [CommonModule, LoggerModule, HttpClientModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.11", ngImport: i0, type: AngularLoggerModule, providers: [AngularLoggerService], imports: [CommonModule, LoggerModule, HttpClientModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.11", ngImport: i0, type: AngularLoggerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, LoggerModule, HttpClientModule],
                    providers: [AngularLoggerService],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { AngularLoggerModule, AngularLoggerService, TOKEN_ANGULAR_LOGGER_USERINFO_SERVICE };
